// =============================================================================
// SLICE S-A3 (A3-4) + S-B (B-4) — Tombol aksi/solusi BERSAMA (satu sumber, tanpa duplikasi).
// Dipakai oleh: StockAlertPage & Dashboard (Notifikasi Stok) DAN kasir/penolakan scan (S-B B-4).
// Perilaku IDENTIK: HANYA MEMBUKA layar dengan produk terpilih (query ?product=<id>).
// TIDAK membuat, TIDAK mengubah, TIDAK menghapus apa pun.
//   wo         -> /work-orders?product=<id>   (Ajukan WO)
//   merch      -> /permintaan?product=<id>    (Ajukan Merchandize)
//   fix-merch  -> /merchandise?product=<id>   (perbaiki harga / rencana jual / "tidak dijual")
//   store-task -> /store-tasks                (terima kiriman)
// =============================================================================
import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { FilePlus, ClipboardPlus, Package, ClipboardCheck } from "lucide-react";

// Satu sumber pemetaan tujuan (dipakai tombol inline & toast aksi kasir).
export const SOLUTION_ROUTE = {
  wo: (pid) => `/work-orders${pid ? `?product=${encodeURIComponent(pid)}` : ""}`,
  merch: (pid) => `/permintaan${pid ? `?product=${encodeURIComponent(pid)}` : ""}`,
  "fix-merch": (pid) => `/merchandise${pid ? `?product=${encodeURIComponent(pid)}` : ""}`,
  "store-task": () => `/store-tasks`,
};

export const solutionRoute = (kind, productId) =>
  (SOLUTION_ROUTE[kind] ? SOLUTION_ROUTE[kind](productId) : null);

const META = {
  wo: { label: "Ajukan WO", Icon: FilePlus },
  merch: { label: "Ajukan Merchandize", Icon: ClipboardPlus },
  "fix-merch": { label: "Perbaiki di Merchandize", Icon: Package },
  "store-task": { label: "Buka Tugas Store", Icon: ClipboardCheck },
};

// Tombol ikon ringkas (dipakai di tabel Notifikasi Stok).
export const StockAlertActionButton = ({ action, productId }) => {
  const navigate = useNavigate();
  const route = solutionRoute(action, productId);
  if (!route) return null;
  const { label, Icon } = META[action] || META.merch;
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            className="h-7 w-7"
            onClick={() => navigate(route)}
            aria-label={label}
            data-testid="v2-stock-action-btn"
          >
            <Icon className="w-4 h-4" />
          </Button>
        </TooltipTrigger>
        <TooltipContent>{label}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

// Tombol solusi berlabel (dipakai di panel penolakan kasir/scan, S-B B-4).
export const SolutionButton = ({ kind, productId, className }) => {
  const navigate = useNavigate();
  const route = solutionRoute(kind, productId);
  if (!route) return null;
  const { label, Icon } = META[kind] || META["fix-merch"];
  return (
    <Button
      variant="outline"
      size="sm"
      className={className}
      onClick={() => navigate(route)}
      data-testid="v2-solution-btn"
    >
      <Icon className="w-4 h-4 mr-1" />
      {label}
    </Button>
  );
};
